import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=252ce00c&scoped=true"
import script from "./WalletBalance.vue?vue&type=script&lang=ts"
export * from "./WalletBalance.vue?vue&type=script&lang=ts"
import style0 from "./WalletBalance.vue?vue&type=style&index=0&id=252ce00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ce00c",
  null
  
)

export default component.exports